export default "__VITE_ASSET__CAE9LAwH__"